import { render, staticRenderFns } from "./MyExams.vue?vue&type=template&id=37e58d5d&scoped=true"
import script from "./MyExams.vue?vue&type=script&lang=js"
export * from "./MyExams.vue?vue&type=script&lang=js"
import style0 from "./MyExams.vue?vue&type=style&index=0&id=37e58d5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e58d5d",
  null
  
)

export default component.exports